module.exports = __webpack_public_path__ + "img/invalid.58405ec4.png";